import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { createStateSyncMiddleware, initStateWithPrevTab } from 'redux-state-sync';

import { setReduxCookies } from "../utilities/setReduxCookies";

import rootReducer from "./reducers/rootReducer";

const data = window.__REDUX_DATA__;
delete window.__REDUX_DATA__;

let initialState
if (data) {
    delete data.tokenExpiresAt;
    initialState = data;
} else {
    initialState = {}
}

const middleware = [thunk, createStateSyncMiddleware({})];

// redux-devtools configuration
// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
    rootReducer,
    initialState,
    applyMiddleware(...middleware)
);

store.subscribe(() => {
    setReduxCookies(store);
});

initStateWithPrevTab(store);

export default store;